export const webCallRoutes = [
  {
    path: '/chamada-web',
    name: 'WebCall',
    meta: {
      requiresAuth: true,
      menu: true
    },
    component: () => import(/* webpackChunkName: 'webcall-page' */ 'views/WebCallPage')
  }
]
